import React, { useEffect, useState } from "react";
import HospitalEmailVerify from "./Components/HospitalDashbord/HospitalEmailVerify";
import HospitalDoctors from "./Components/HospitalMySavedItems/HospitalDoctors";
import HospitalHospitals from "./Components/HospitalMySavedItems/HosptialHospitals";

const HospitalMySavedItems = () => {
    const [userdata, setUserdata] = useState({});
    const [tabsest, setTabseset] = useState("Personal Details");

    useEffect(() => {
        const userData = localStorage.getItem("userData");
        console.log("userData", userData);
        if (userData) {
            setUserdata(userData);
        }
    }, []);

    return (
        <>
            <div className="subbody" style={{ width: '100%', padding: '2% 4%' }}>
                {userdata.activation_key == null && (
                    <HospitalEmailVerify />
                )}

                <section className="dc-haslayout dc-dbsectionspace">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9">
                            <form className="dc-user-account" method="post">
                                <div className="dc-dashboardbox dc-dashboardtabsholder dc-accountsettingholder">
                                    <div className="dc-dashboardtabs">
                                        <ul className="dc-tabstitle nav navbar-nav">
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Doctors" ? 'active' : ''} `} href="#" onClick={() => setTabseset("Doctors")}>
                                                    Doctors
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Hosptials" ? 'active' : ''} `} href="#" onClick={() => setTabseset("Hosptials")}>
                                                    Hosptials
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    {tabsest == "Doctors" && (
                                      <HospitalDoctors/>  
                                    )}
                                    {tabsest == "Hosptials" && (
                                      <HospitalHospitals/>  
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default HospitalMySavedItems;
